import Vue from 'vue';
import { 
  Picker,
  Field,
  Popup,
  Col, 
  Row,
  SwipeCell,
  Button,
  Checkbox,
  Tag,
  ImagePreview,
  Icon,
  CheckboxGroup,
  Cell,
  CellGroup,
  Uploader,
  DatetimePicker,
  Divider,
  Radio,
  RadioGroup,
  PullRefresh,
  List,
  Empty,
 } from 'vant';

Vue.use(Picker);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Col);
Vue.use(Row);
Vue.use(SwipeCell);
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(Tag);
Vue.use(ImagePreview);
Vue.use(Icon);
Vue.use(CheckboxGroup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Uploader);
Vue.use(DatetimePicker);
Vue.use(Divider);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Empty);